import React, { useRef } from 'react'
import { motion, useInView } from 'framer-motion'
import OUTCOME_IMAGE from '../../../../app/assets/images/projectImage/cryoneimage/laptop_bg.png'
import COIN5_IMAGE from '../../../../app/assets/images/projectImage/cryoneimage/coin5.png'

type CryoneDreamProps = {
    cryoneProject: any
}

const CryoneDream = ({ cryoneProject }: CryoneDreamProps) => {
    const sectionRef = useRef(null)
    const isInView = useInView(sectionRef, { once: false, amount: 0.2 })
    const { cryoneProjectDetails } = cryoneProject ?? {}
    const { outcomeSection } = cryoneProjectDetails ?? {}

    const fadeUp = {
        hidden: { opacity: 0, y: 34 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.72, ease: [0.22, 1, 0.36, 1] } }
    }

    return (
        <section className='relative bg-[#141414] px-4 sm:px-6 md:px-8 py-16 sm:py-20 overflow-hidden' ref={sectionRef}>

            <div className='relative max-w-[1280px] mx-auto'>
                <motion.div className="flex items-center justify-center gap-4 mb-10" variants={fadeUp} initial="hidden" animate={isInView ? 'visible' : 'hidden'}>
                    <span className="w-3 h-3 rounded-full bg-[#B41F1F]" />
                    <h2 className="uppercase font-extrabold tracking-[1.5px] text-[40px] sm:text-[56px] md:text-[75px] text-white text-center">
                        {outcomeSection?.title}
                    </h2>
                    <span className="w-3 h-3 rounded-full bg-[#B41F1F]" />
                </motion.div>

                <motion.img
                    src={COIN5_IMAGE}
                    alt="Cryone outcome coin"
                    className="pointer-events-none absolute right-[8%] sm:right-[15%] top-[12%] sm:top-[20%] z-30 w-[70px] sm:w-[115px] md:w-[140px]"
                    animate={isInView ? { y: [0, -12, 0], rotate: [0, 8, 0] } : {}}
                    transition={{ duration: 3.8, repeat: Infinity, ease: 'easeInOut' }}
                />

                <motion.div
                    className="relative z-10 mt-2 flex justify-center"
                    style={{ width: '100vw', marginLeft: 'calc(-50vw + 50%)' }}
                    variants={fadeUp}
                    initial="hidden"
                    animate={isInView ? 'visible' : 'hidden'}
                >
                    <motion.img
                        src={OUTCOME_IMAGE}
                        alt="Cryone outcome preview"
                        className="w-screen max-w-none drop-shadow-[0_25px_45px_rgba(0,0,0,0.6)]"
                        whileHover={{ y: -5, transition: { duration: 0.25 } }}
                    />
                </motion.div>

                <motion.p className="mt-12 text-center text-white text-[18px] sm:text-[22px] md:text-[26px] leading-[1.45] max-w-[1080px] mx-auto" variants={fadeUp} initial="hidden" animate={isInView ? 'visible' : 'hidden'}>
                    {outcomeSection?.description}
                </motion.p>
            </div>
        </section>
    )
}

export default CryoneDream
